export default class DeliveryAndPaymentService {
    constructor() {
        this.form = null;
        this.shippingZoneSelect = null;
        this.shippingMethodSelect = null;
        this.resultTemplate = null;
        this.onCalculationSubmit = (event) => {
            var _a, _b, _c, _d, _e, _f;
            event.preventDefault();
            const submitter = event.submitter;
            if (!submitter || submitter.type !== 'submit') {
                return;
            }
            submitter.disabled = true;
            setTimeout(() => {
                submitter.disabled = false;
            }, 100);
            if (this.form && this.resultTemplate) {
                const data = this.serializeFormData(this.form);
                const prevResult = this.form.querySelector('.result');
                if (prevResult) {
                    const newResult = this.resultTemplate.cloneNode(true);
                    newResult.style.display = 'flex';
                    const freeShippingValue = newResult.querySelector('.free-shipping-value');
                    const resultInfoTimings = newResult.querySelector('.result-info-timings');
                    const resultInfoPrice = newResult.querySelector('.result-info-price');
                    try {
                        const shippingMethod = JSON.parse(data.shipping_method);
                        const deliveryZone = JSON.parse(data.shipping_zone);
                        console.log({
                            shippingMethod,
                            deliveryZone,
                        });
                        if (deliveryZone.free_shipping) {
                            freeShippingValue.innerHTML = (_a = deliveryZone.free_shipping) !== null && _a !== void 0 ? _a : '';
                        }
                        else {
                            (_b = freeShippingValue.parentElement) === null || _b === void 0 ? void 0 : _b.remove();
                        }
                        if (shippingMethod.shipping_time) {
                            resultInfoTimings.innerHTML = (_c = shippingMethod.shipping_time) !== null && _c !== void 0 ? _c : '';
                        }
                        else {
                            (_d = resultInfoTimings.parentElement) === null || _d === void 0 ? void 0 : _d.remove();
                        }
                        if (shippingMethod.static_cost_display) {
                            resultInfoPrice.innerHTML = (_e = shippingMethod.static_cost_display) !== null && _e !== void 0 ? _e : '';
                        }
                        else {
                            (_f = resultInfoPrice.parentElement) === null || _f === void 0 ? void 0 : _f.remove();
                        }
                        prevResult.remove();
                        this.form.appendChild(newResult);
                    }
                    catch (e) {
                        console.error(e);
                    }
                }
            }
        };
        this.setupCalc = () => {
            var _a, _b, _c, _d;
            this.shippingZoneSelect = document.getElementById('shipping_zone');
            this.shippingMethodSelect = document.getElementById('shipping_method');
            if (this.shippingZoneSelect) {
                this.shippingZoneSelect.disabled = false;
                this.shippingZoneSelect.addEventListener('change', (e) => {
                    this.onZoneSelect(e);
                });
            }
            if (this.shippingMethodSelect) {
                this.shippingMethodSelect.addEventListener('change', (e) => {
                    this.onMethodSelect(e);
                });
            }
            this.form = document.querySelector('.delivery-calc .perla-form');
            (_a = this.form) === null || _a === void 0 ? void 0 : _a.addEventListener('submit', this.onCalculationSubmit);
            const resultTemplate = (_b = this.form) === null || _b === void 0 ? void 0 : _b.querySelector('.result');
            if (resultTemplate) {
                const cloned = resultTemplate.cloneNode(true);
                if (cloned) {
                    this.resultTemplate = cloned;
                }
            }
            (_d = (_c = this.form) === null || _c === void 0 ? void 0 : _c.querySelector('.additional-buttons')) === null || _d === void 0 ? void 0 : _d.addEventListener('click', (e) => {
                const target = e.target;
                const { code } = target.dataset;
                if (target && target.matches('button') && this.shippingZoneSelect && code) {
                    const options = this.shippingZoneSelect.querySelectorAll('option');
                    options.forEach((option, index) => {
                        var _a;
                        if (this.shippingZoneSelect && ((_a = option.value) !== null && _a !== void 0 ? _a : '').includes(code)) {
                            this.shippingZoneSelect.selectedIndex = index;
                            this.shippingZoneSelect.dispatchEvent(new Event('change'));
                        }
                    });
                }
            });
        };
    }
    updateMethodOptions(shippingMethods) {
        if (!this.shippingMethodSelect) {
            return;
        }
        this.shippingMethodSelect.innerHTML = '<option value=""></option>';
        shippingMethods.forEach((method) => {
            var _a;
            const option = document.createElement('option');
            option.text = method.method_title;
            option.value = JSON.stringify(method);
            (_a = this.shippingMethodSelect) === null || _a === void 0 ? void 0 : _a.appendChild(option);
        });
        this.updateShippingMethodLogo('');
    }
    updateFlag(code) {
        if (!this.shippingZoneSelect) {
            return;
        }
        const shippingZoneSelectContainer = this.shippingZoneSelect.parentElement;
        if (!shippingZoneSelectContainer) {
            return;
        }
        const previousFlag = shippingZoneSelectContainer.querySelector('.selected-flag-icon');
        if (previousFlag) {
            previousFlag.remove();
        }
        if (!code) {
            return;
        }
        const flagElement = document.createElement('div');
        flagElement.className = `iti__flag iti__${code.toLowerCase()} selected-flag-icon`;
        shippingZoneSelectContainer.appendChild(flagElement);
    }
    updateShippingMethodLogo(src) {
        if (!this.shippingMethodSelect) {
            return;
        }
        const shippingMethodSelectContainer = this.shippingMethodSelect.parentElement;
        if (!shippingMethodSelectContainer) {
            return;
        }
        const previousIcon = shippingMethodSelectContainer.querySelector('.selected-icon');
        if (previousIcon) {
            previousIcon.remove();
        }
        if (!src) {
            return;
        }
        const imageElement = document.createElement('img');
        imageElement.src = src;
        const selectedIcon = document.createElement('div');
        selectedIcon.className = `selected-icon`;
        selectedIcon.appendChild(imageElement);
        shippingMethodSelectContainer.appendChild(selectedIcon);
    }
    hideResultContainer() {
        if (this.form) {
            const resultContainer = this.form.querySelector('.result');
            resultContainer.style.display = 'none';
        }
    }
    onZoneSelect(e) {
        const target = e.target;
        const selectedOption = target.options[target.selectedIndex];
        if (!selectedOption.value) {
            this.updateFlag('');
            return;
        }
        try {
            const data = JSON.parse(selectedOption.value);
            this.updateFlag(data.country_code);
            this.updateMethodOptions(data.shipping_methods);
            this.hideResultContainer();
        }
        catch (error) {
            console.error('Invalid JSON in data-value:', error);
        }
    }
    onMethodSelect(e) {
        const target = e.target;
        const selectedOption = target.options[target.selectedIndex];
        if (!selectedOption.value) {
            this.updateShippingMethodLogo('');
            return;
        }
        try {
            const data = JSON.parse(selectedOption.value);
            this.updateShippingMethodLogo(data.method_logo);
            this.hideResultContainer();
        }
        catch (error) {
            console.error('Invalid JSON in data-value:', error);
        }
    }
    serializeFormData(form) {
        if (!form) {
            return {};
        }
        const formData = new FormData(form);
        const data = Object.fromEntries(formData.entries());
        return data;
    }
    init() {
        try {
            this.setupCalc();
        }
        catch (e) {
            console.error(e);
        }
    }
}
